import { HttpClient } from '@angular/common/http';
import { inject, Injectable } from '@angular/core';
import { BehaviorSubject, forkJoin, Observable, tap } from 'rxjs';
import {
  CountryCreateRequestDTO,
  CountryDeleteRequestDTO,
  CountryDTO,
  CountryList,
  CountryReadByIdRequestDTO,
  CountryUpdateRequestDTO
} from './country.interface';
import {
  Country_create,
  Country_delete,
  Country_readById,
  Country_update,
  Country_readAll
} from 'src/app/GlobalVariables';
import { StateService } from '../state/state.service';
import { CitiesService } from '../cities/cities.service';
import { StateDTO } from '../state/state.interface';
import { CitiesDTO } from '../cities/cities.interface';


@Injectable({
  providedIn: 'root'
})
export class CountryService {

  constructor() { }
  countries$ = new BehaviorSubject<CountryDTO[]>([])

  http = inject(HttpClient);

  Country_create(data: CountryCreateRequestDTO): Observable<CountryDTO> {
    return this.http.post<CountryDTO>(Country_create, data)
  }

  Country_update(data: CountryUpdateRequestDTO): Observable<CountryDTO> {
    return this.http.post<CountryDTO>(Country_update, data)
  }

  Country_delete(data: CountryDeleteRequestDTO): Observable<void> {
    return this.http.post<void>(Country_delete, data)
  }

  Country_ReadByID(data: CountryReadByIdRequestDTO): Observable<CountryDTO> {
    return this.http.post<CountryDTO>(Country_readById, data)
  }

  Country_ReadAll(): Observable<CountryList> {
    return this.http.get<CountryList>(Country_readAll).pipe(tap(res => {
      if (res?.items) {
        this.countries$.next(res.items.sort((a, b) => (a.countryName ?? '').localeCompare(b.countryName ?? '')));
      } else {
        this.countries$.next([]); // Ensure next() is always called
      }
    }));
  }

  
}
